// extracted by mini-css-extract-plugin
export default {"deleteButton":"EditSpecificationModalContent-deleteButton-dR0rN Button-button-paJ9a Link-link-RInnp"};